var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReporticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.4027H12.5235V13.2752H5.5V14.4027ZM5.5 10.4094H12.5V9.28188H5.5V10.4094ZM4.02013 17.9262C3.44494 17.9262 2.9645 17.7332 2.57879 17.3474C2.19293 16.9617 2 16.4812 2 15.906V2.09396C2 1.51892 2.19293 1.03848 2.57879 0.652614C2.9645 0.266753 3.44494 0.073822 4.02013 0.073822H11.2081L16 4.84228V15.906C16 16.4812 15.8071 16.9617 15.4212 17.3474C15.0353 17.7332 14.5549 17.9262 13.9799 17.9262H4.02013ZM10.5973 5.47651V1.34228H4.02013C3.83221 1.34228 3.65996 1.42058 3.50336 1.57718C3.34676 1.73378 3.26846 1.90604 3.26846 2.09396V15.906C3.26846 16.094 3.34676 16.2662 3.50336 16.4228C3.65996 16.5794 3.83221 16.6577 4.02013 16.6577H13.9799C14.1678 16.6577 14.34 16.5794 14.4966 16.4228C14.6532 16.2662 14.7315 16.094 14.7315 15.906V5.47651H10.5973Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporticon);
export default __webpack_public_path__ + "static/media/reporticon.6d4a22814d932590f41f19787a957aa8.svg";
export { ForwardRef as ReactComponent };